export const VALUATIONS_TERTIARY_NAVIGATION_LABELS = {
  FIRM_SUMMARY: 'Firm Valuations',
} as const;

export const VALUATIONS_TERTIARY_NAVIGATION_SLUGS = {
  FIRM_SUMMARY: 'firm-valuations',
} as const;

export const VALUATIONS_DEFAULT_TERTIARY_NAVIGATION_SLUG =
  VALUATIONS_TERTIARY_NAVIGATION_SLUGS.FIRM_SUMMARY;

export const VALUATIONS_CUSTOM_VIEW_SLUG_PREFIX = 'view-';
